<template>
    <ur-modal ref="modal" title="변경요청 상세" large>
        <table class="tbl_list">
            <colgroup>
                <col style="width:167px">
                <col style="width:auto">
            </colgroup>
            <tbody>
                <tr>
                    <th>요청구분</th>
                    <td>{{typeText}}</td>
                </tr>
                <tr>
                    <th>요청자</th>
                    <td>{{srRequestUser}} ({{srRequestDate}})</td>
                </tr>
                <tr>
                    <th>상태</th>
                    <td>
                        <div>{{statusText}}<span v-if="srStatusCode != 'A'"> {{srCompleteDate}}</span></div>
                        <div v-if="srContents != null && srContents != '' " style="margin-top:16px">{{srContents}}</div>
                    </td>
                </tr>
                <tr>
                    <th>전화번호/채널</th>
                    <td><ur-data-grid style="margin-top:-8px;" :options="options" :headers="headers" :data-source="sipNumberList"/></td>
                </tr>
            </tbody>
        </table>

        <!--
        <ur-form-box column="1" small>
            <ur-form-item label="요청구분">{{typeText}}</ur-form-item>
            <ur-form-item label="요청">{{srRequestUser}} / ({{srRequestDate}})</ur-form-item>
            <ur-form-item v-if="srStatusCode=='C'" label="상태" noFlex>
                <div>
                    <span>{{statusText}} ({{srCompleteDate}})</span>
                    <br>
                    <span>{{srContents}}</span>
                </div>
            </ur-form-item>
            <ur-form-item v-else label="상태">{{statusText}}</ur-form-item>
        </ur-form-box>
        -->
        <!--<ur-data-grid :options="options" :headers="headers" :data-source="sipNumberList"/>-->
        <template slot="action">
            <ur-button @click="close" primary solid>확인</ur-button>
        </template>
    </ur-modal>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
export default {
    name:'PGE_AIS_00001_P01',
    components:{
        urDataGrid,
    },
    props:{
    },
    extends:BasePage,
    data(){
        return {
            srId:'',
            srTypeCode:'',
            srStatusCode:'',
            srRequestUser:'',
            srRequestDate:'',
            srCompleteDate:'',
            srContents:'',
            sipNumberList:[],
            options:{
                noInfo:true,
                infinityScroll:true,
                height:172,
                msgEmptyData:' ',
                selectCheckOnly:true,
            },
            headers : [
                {text:'전화번호', value:'sipNumber', sort:true,
                    customValue:(v, r) => aiccUtils.phoneNumberFormat.format(v),
                },
                {text:'채널', value:'channels', sort:true, },
                {text:'요청상세', value:'sipNumberStatusCode',

                    customValue:(v, r)=>{
                        switch(v) {
                            case 'B':
                                return '신규요청';
                            case 'C' :
                                return '채널변경';
                            case 'E':
                                return '해지요청';
                            default:
                                return '';
                        }
                    }
                },
            ],
        }
    },
    computed:{
        typeText(){
            if(this.srTypeCode === 'A') {
                return '전화번호/채널 신규요청';
            } else if(this.srTypeCode === 'B'){
                return '전화번호/채널 변경요청';
            }
            return '';
        },
        statusText(){
            if(this.srStatusCode === 'A') {
                return '접수중';
            } else if(this.srStatusCode === 'B'){
                return '승인';
            } else if(this.srStatusCode === 'C') {
                return '반려';
            }
            return '';
        },
    },
    methods:{
        open(srId){
            this.srId = srId;
            this.getSrDetail();
        },
        close(){
            this.$refs.modal.close();
            this.$emit('close');
        },
        getSrDetail(){
            http.request(this.contextPageId, 'DTS_AIS_00002', {
                path: {
                    'service-request-id':this.srId
                }
            }).then(res => {
                //console.log(res.data);
                this.srTypeCode = res.data.serviceRequestInfo.srType;
                this.srStatusCode = res.data.serviceRequestInfo.srStatusCode;
                this.srRequestUser = res.data.serviceRequestInfo.requestUserName;
                this.srRequestDate = utils.toStringByFormat(utils.toDate(res.data.serviceRequestInfo.firstRegistrationDTM), 'YYYY-MM-DD');
                if(res.data.serviceRequestInfo.finalModificationDTM && res.data.serviceRequestInfo.finalModificationDTM != '') {
                    this.srCompleteDate = '(' + utils.toStringByFormat(utils.toDate(res.data.serviceRequestInfo.finalModificationDTM), 'YYYY-MM-DD HH:mm') + ')';
                } else  {
                    this.srCompleteDate = '';
                }
                
                this.srContents = res.data.serviceRequestInfo.srContents;
                this.sipNumberList = [];
                for(let index in res.data.serviceRequestSipNumberList) {
                    this.sipNumberList.push(res.data.serviceRequestSipNumberList[index]);
                }
                this.options.msgEmptyData = '';
                this.$refs['modal'].open();
            });
        },
    },
}
</script>
<style scoped>
    
    .tbl_list {
        width:100%;
    }
    .tbl_list th {
        padding: 16px 0 16px 32px;
        line-height: 24px;
        font-size: 16px;
        text-align: left;
        vertical-align: top;
        font-weight: 500;
    }
    .tbl_list td {
        padding: 16px 0;
        line-height: 24px;
        font-size: 16px;
        text-align: left;
        vertical-align: top;
    }
    .ur-data-grid {
        min-width: 0px;
        width:100%;
    }
</style>